import { useEffect } from 'react'
import { useActions } from 'statux'
import { getCssVar, setCssVar } from '../../utils/css'
import { setCookie } from '../../utils/cookies'
import useWindowSize from '../../hooks/useWindowSize'
import RichText from '../RichText/RichText'

export default function CookieBanner (props = {
    richText: null,
    modified: null,
    denyBtnText: null,
    acceptBtnText: null
}) {
    let cookieBanner

    const setCookieBanner = useActions('cookieBanner')

    const id = props.slug
        && props.modified
        && `${props.slug}-${props.modified}`

    const setCookieBannerCssVar = () => {
        const bannerHeight = `${(cookieBanner
            || document.getElementById(id)
            || {}).clientHeight || 0}px`

        if (bannerHeight !== getCssVar('--cookie-banner-height'))
            setCssVar('--cookie-banner-height', cookieBanner
                && bannerHeight)
    }

    useEffect(() => {
        setCookieBannerCssVar()
        return setCookieBannerCssVar
    }, [cookieBanner, useWindowSize()])

    if (!props.richText)
        return null

    const onBtnClick = (type) => {
        setCookie(id, type, { expires: 365 })

        setCookieBanner
            && setCookieBanner(false)

        if (window.gtag)
            window.gtag('consent', 'update', {
                analytics_storage: type
            })
    }

    return (
        <div
            id={id}
            className="cookie-banner theme-dark"
            ref={(ref) => (cookieBanner = ref)}
        >
            <div className="container pad-3-b pad-3-t">
                <div className="row flex-justify-content-space-between flex-align-items-center">
                    <div className="col col-7-lg-up body-3">
                        <RichText
                            html={props.richText}
                        />
                    </div>
                    <div className="col-auto col-12-md-down pad-3-t-md-down">
                        <div className="row-condensed margin-1-b-neg">
                            <div className="col display-flex margin-1-b">
                                <button
                                    className="btn-outline flex-grow"
                                    onClick={() => onBtnClick('denied')}
                                >
                                    {props.denyBtnText || 'Deny'}
                                </button>
                            </div>
                            <div className="col display-flex margin-1-b">
                                <button
                                    className="flex-grow"
                                    onClick={() => onBtnClick('granted')}
                                >
                                    {props.acceptBtnText || 'Accept'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
